import Credit from '@/components/RechargeCredit/Forms/Credit.vue';
import Voucher from '@/components/RechargeCredit/Forms/Voucher.vue';

export default {
    components: {
        Credit,
        Voucher,
    },
};
